"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDL = void 0;
exports.IDL = {
    "version": "0.1.0",
    "name": "structured",
    "instructions": [
        {
            "name": "initialize",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "derivativeTokenMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quoteTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "quoteTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bump",
                    "type": "u8"
                },
                {
                    "name": "authorityBump",
                    "type": "u8"
                },
                {
                    "name": "derivativeMintBump",
                    "type": "u8"
                },
                {
                    "name": "vaultBumps",
                    "type": {
                        "defined": "VaultBumps"
                    }
                },
                {
                    "name": "decimals",
                    "type": "u8"
                },
                {
                    "name": "vaultCap",
                    "type": "u128"
                }
            ]
        },
        {
            "name": "createUserAccount",
            "accounts": [
                {
                    "name": "userAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "user",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "closeUserAccount",
            "accounts": [
                {
                    "name": "userAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "setAdmin",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "pendingAdmin",
                    "type": "publicKey"
                }
            ]
        },
        {
            "name": "acceptAdmin",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pendingAdmin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "raiseVaultCap",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "newCap",
                    "type": "u128"
                }
            ]
        },
        {
            "name": "pause",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "unpause",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "expire",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "enableEarlyAccess",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "disableEarlyAccess",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "setEarlyAccessMint",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "tokenMint",
                    "type": "publicKey"
                }
            ]
        },
        {
            "name": "createOpenOrders",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "createPricePerSharePage",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "pricePerSharePage",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bump",
                    "type": "u8"
                },
                {
                    "name": "pageIndex",
                    "type": "u128"
                }
            ]
        },
        {
            "name": "deposit",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pricePerSharePage",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "userAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userUnderlyingTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userEarlyAccessTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "userAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "amount",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "depositAll",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pricePerSharePage",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "userAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userUnderlyingTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userEarlyAccessTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "userAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "claimShares",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pricePerSharePage",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "userAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userDerivativeTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "initiateWithdraw",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userDerivativeTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "amount",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "completeWithdraw",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pricePerSharePage",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "userAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userUnderlyingTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "instantWithdraw",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userUnderlyingTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "amountUnderlying",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "withdrawExpired",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userUnderlyingTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userDerivativeTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pricePerSharePage",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "rollToNextOption",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "quoteTokenVault",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "pricePerSharePage",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "derivativeTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionTokenMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "zetaFlexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexState",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexUnderlying",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexVaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "initializeAuction",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "zetaFlexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexState",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexVaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "auctionVault",
                    "isMut": true,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "timestamp",
                    "type": "u64"
                },
                {
                    "name": "auctionBump",
                    "type": "u8"
                },
                {
                    "name": "auctionVaultBump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "completeAuction",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "zetaFlexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexState",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexVaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "auctionVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidder",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidderAuctionTokenAccount",
                    "isMut": true,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "expectedAmount",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "cancelAuction",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidTokenVault",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexState",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "auctionVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexVaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "zetaFlexProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "initOptionParameters",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionParameters",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "optionParametersBump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "setNextOption",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "optionParameters",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "expiry",
                    "type": "u64"
                },
                {
                    "name": "strike",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "mintOptions",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionParameters",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "zetaFlexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "mintAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexState",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexUnderlying",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexVaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "optionAccountBump",
                    "type": "u8"
                },
                {
                    "name": "optionMintBump",
                    "type": "u8"
                },
                {
                    "name": "tokenAccountBump",
                    "type": "u8"
                },
                {
                    "name": "vaultBump",
                    "type": "u8"
                },
                {
                    "name": "oracleMethod",
                    "type": {
                        "defined": "OracleMethod"
                    }
                }
            ]
        },
        {
            "name": "buyUnderlying",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "requestQueue",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "eventQueue",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bids",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "asks",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "coinVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quoteTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "limitPrice",
                    "type": "u64"
                },
                {
                    "name": "amount",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "cancelBuyOrder",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "eventQueue",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bids",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "asks",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "orderId",
                    "type": "u128"
                }
            ]
        },
        {
            "name": "settle",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "quoteTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "dexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "market",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "openOrders",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "coinVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "pcVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultSigner",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "createOtcTerms",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "otcTerms",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenMintToSell",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenMintToBuy",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "bump",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "closeOtcTerms",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "otcTerms",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "setOtcTerms",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "otcTerms",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "totalPrice",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "cancelOtcTerms",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "otcTerms",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "fillOtcOrder",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "otcTerms",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "buyerAcquiringTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "buyerPayingTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenToSellVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenToBuyVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userAuthority",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "setExpireOverride",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexState",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexUnderlying",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexVault",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "zetaFlexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "overridePrice",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "burnOptions",
            "accounts": [
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlyingTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionTokenVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexState",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "flexVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "flexVaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "mintAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionTokenMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "zetaFlexProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        }
    ],
    "accounts": [
        {
            "name": "state",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "admin",
                        "type": "publicKey"
                    },
                    {
                        "name": "pendingAdmin",
                        "type": "publicKey"
                    },
                    {
                        "name": "vaultAuthority",
                        "type": "publicKey"
                    },
                    {
                        "name": "cap",
                        "type": "u128"
                    },
                    {
                        "name": "lockedAmount",
                        "type": "u128"
                    },
                    {
                        "name": "lastLockedAmount",
                        "type": "u128"
                    },
                    {
                        "name": "totalPendingDeposits",
                        "type": "u128"
                    },
                    {
                        "name": "queuedWithdrawShares",
                        "type": "u128"
                    },
                    {
                        "name": "totalShares",
                        "type": "u128"
                    },
                    {
                        "name": "round",
                        "type": "u128"
                    },
                    {
                        "name": "underlyingTokenMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "quoteTokenMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "optionTokenMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "nextOptionTokenMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "nextOptionTokenVault",
                        "type": "publicKey"
                    },
                    {
                        "name": "writerTokenMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "optionAccount",
                        "type": "publicKey"
                    },
                    {
                        "name": "status",
                        "type": {
                            "defined": "VaultStatus"
                        }
                    },
                    {
                        "name": "padding",
                        "type": {
                            "array": [
                                "u8",
                                30
                            ]
                        }
                    },
                    {
                        "name": "isExpired",
                        "type": "bool"
                    },
                    {
                        "name": "derivativeTokenMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "earlyAccessTokenMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "underlyingTokenVault",
                        "type": "publicKey"
                    },
                    {
                        "name": "quoteTokenVault",
                        "type": "publicKey"
                    },
                    {
                        "name": "optionTokenVault",
                        "type": "publicKey"
                    },
                    {
                        "name": "writerTokenVault",
                        "type": "publicKey"
                    },
                    {
                        "name": "derivativeTokenVault",
                        "type": "publicKey"
                    },
                    {
                        "name": "openOrders",
                        "type": "publicKey"
                    },
                    {
                        "name": "decimals",
                        "type": "u8"
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    },
                    {
                        "name": "authorityBump",
                        "type": "u8"
                    },
                    {
                        "name": "derivativeMintBump",
                        "type": "u8"
                    },
                    {
                        "name": "vaultBumps",
                        "type": {
                            "defined": "VaultBumps"
                        }
                    },
                    {
                        "name": "pendingVaultBumps",
                        "type": {
                            "defined": "PendingVaultBumps"
                        }
                    },
                    {
                        "name": "isPaused",
                        "type": "bool"
                    },
                    {
                        "name": "onlyEarlyAccess",
                        "type": "bool"
                    }
                ]
            }
        },
        {
            "name": "userVaultAccount",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "owner",
                        "type": "publicKey"
                    },
                    {
                        "name": "depositData",
                        "type": {
                            "defined": "PendingDepositData"
                        }
                    },
                    {
                        "name": "withdrawData",
                        "type": {
                            "defined": "PendingWithdrawData"
                        }
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "pricePerSharePage",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "page",
                        "type": "u128"
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    },
                    {
                        "name": "prices",
                        "type": {
                            "array": [
                                "u128",
                                128
                            ]
                        }
                    }
                ]
            }
        },
        {
            "name": "optionParameters",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "state",
                        "type": "publicKey"
                    },
                    {
                        "name": "expiry",
                        "type": "u64"
                    },
                    {
                        "name": "strike",
                        "type": "u64"
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "otcTerms",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "round",
                        "type": "u128"
                    },
                    {
                        "name": "totalPrice",
                        "type": "u64"
                    },
                    {
                        "name": "tokenMintToBuy",
                        "type": "publicKey"
                    },
                    {
                        "name": "tokenMintToSell",
                        "type": "publicKey"
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    }
                ]
            }
        }
    ],
    "types": [
        {
            "name": "PendingDepositData",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "round",
                        "type": "u128"
                    },
                    {
                        "name": "amount",
                        "type": "u128"
                    },
                    {
                        "name": "unredeemedShares",
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "PendingWithdrawData",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "round",
                        "type": "u128"
                    },
                    {
                        "name": "shares",
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "VaultBumps",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "underlying",
                        "type": "u8"
                    },
                    {
                        "name": "quote",
                        "type": "u8"
                    },
                    {
                        "name": "option",
                        "type": "u8"
                    },
                    {
                        "name": "writer",
                        "type": "u8"
                    },
                    {
                        "name": "derivative",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "PendingVaultBumps",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "option",
                        "type": "u8"
                    },
                    {
                        "name": "writer",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "SelfTradeBehavior",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "DecrementTake"
                    },
                    {
                        "name": "CancelProvide"
                    },
                    {
                        "name": "AbortTransaction"
                    }
                ]
            }
        },
        {
            "name": "OrderType",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Limit"
                    },
                    {
                        "name": "ImmediateOrCancel"
                    },
                    {
                        "name": "PostOnly"
                    }
                ]
            }
        },
        {
            "name": "NewSide",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Bid"
                    },
                    {
                        "name": "Ask"
                    }
                ]
            }
        },
        {
            "name": "Status",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Default"
                    },
                    {
                        "name": "RollToNextOption"
                    },
                    {
                        "name": "MintOptions"
                    },
                    {
                        "name": "SellOptions"
                    },
                    {
                        "name": "SettleOptionSale"
                    },
                    {
                        "name": "BuyUnderlying"
                    },
                    {
                        "name": "SettleExercisedOptions"
                    },
                    {
                        "name": "Settle"
                    },
                    {
                        "name": "SettleExpiredOptions"
                    },
                    {
                        "name": "CommitNextOption"
                    }
                ]
            }
        },
        {
            "name": "VaultStatus",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "CompleteAuction"
                    },
                    {
                        "name": "RollToNextOption"
                    },
                    {
                        "name": "SetOptionParameters"
                    },
                    {
                        "name": "MintOptions"
                    },
                    {
                        "name": "InitializeAuction"
                    },
                    {
                        "name": "CancelAuction"
                    }
                ]
            }
        },
        {
            "name": "OracleMethod",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "SpotPrint"
                    },
                    {
                        "name": "ManualPrint"
                    }
                ]
            }
        }
    ],
    "errors": [
        {
            "code": 6000,
            "name": "InvalidUserAmount",
            "msg": "Invalid amount requested by user"
        },
        {
            "code": 6001,
            "name": "ZeroAmount",
            "msg": "Must be nonzero"
        },
        {
            "code": 6002,
            "name": "InvalidRound",
            "msg": "Must be current round"
        },
        {
            "code": 6003,
            "name": "RoundInProgress",
            "msg": "Round is still in progress"
        },
        {
            "code": 6004,
            "name": "RedeemBeforeWithdraw",
            "msg": "Must redeem all shares before withdraw"
        },
        {
            "code": 6005,
            "name": "CompleteExistingWithdraw",
            "msg": "Complete existing withdraw before initiating new withdrawal"
        },
        {
            "code": 6006,
            "name": "IncorrectPricePerSharePage",
            "msg": "Incorrect price per share page passed in"
        },
        {
            "code": 6007,
            "name": "NextOptionInvalid",
            "msg": "Next option is not set or invalid"
        },
        {
            "code": 6008,
            "name": "ArithmeticError",
            "msg": "Arithmetic error"
        },
        {
            "code": 6009,
            "name": "VaultCapExceeded",
            "msg": "Vault cap exceeded"
        },
        {
            "code": 6010,
            "name": "Paused",
            "msg": "Vault is paused"
        },
        {
            "code": 6011,
            "name": "LowerVaultCap",
            "msg": "Vault cap lower than current"
        },
        {
            "code": 6012,
            "name": "FundsInUse",
            "msg": "Funds are currently in use. Withdrawals must be queued"
        },
        {
            "code": 6013,
            "name": "OnlyTicketHolders",
            "msg": "Must own an early access token"
        },
        {
            "code": 6014,
            "name": "InvalidOTCTerms",
            "msg": "OTC terms are invalid"
        },
        {
            "code": 6015,
            "name": "InvalidEarlyAccessMint",
            "msg": "Invalid early access token used"
        },
        {
            "code": 6016,
            "name": "InvalidEarlyAccessOwner",
            "msg": "Owner of early access token does not match"
        },
        {
            "code": 6017,
            "name": "InvalidEnableAccess",
            "msg": "Early access token mint must be set to enable early access"
        },
        {
            "code": 6018,
            "name": "InvalidOTCPair",
            "msg": "OTC terms must occur between certain pairs of tokens"
        },
        {
            "code": 6019,
            "name": "AuctionTimestampOutofSync",
            "msg": "Starting timestamp must be close to onchain clock timestamp"
        },
        {
            "code": 6020,
            "name": "PreviousOptionsNotSettled",
            "msg": "Must collect remaining collateral for the previous option before minting new options"
        },
        {
            "code": 6021,
            "name": "OptionsNotInitialized",
            "msg": "Must first initialize options before initializing the auction"
        },
        {
            "code": 6022,
            "name": "OptionsMustExpireInFuture",
            "msg": "Options must expire in the future"
        },
        {
            "code": 6023,
            "name": "OptionsExpiryOutOfRange",
            "msg": "Options expire too far in the future"
        },
        {
            "code": 6024,
            "name": "OptionsNonzeroAmount",
            "msg": "Must mint nonzero option amount"
        },
        {
            "code": 6025,
            "name": "InvalidStatusForAction",
            "msg": "Incorrect state status for action"
        },
        {
            "code": 6026,
            "name": "QuoteTokensExceedThreshold",
            "msg": "Too many quote tokens remaining"
        },
        {
            "code": 6027,
            "name": "OptionTokensRemaining",
            "msg": "Option tokens remaining in the vault"
        },
        {
            "code": 6028,
            "name": "Expired",
            "msg": "Vault is expired: deposits are not allowed"
        },
        {
            "code": 6029,
            "name": "NotExpired",
            "msg": "Vault is not expired: cannot withdraw expired"
        }
    ]
};
